module.exports = __webpack_public_path__ + "img/aboutus.75dd42b2.svg";